import { SITE_MAP } from 'globalConstants';
import Link from 'next/link';

const HomeLink = () => (
  <Link
    id='home-link'
    href={`/${SITE_MAP.SOCIAL_NETWORK.INDEX}/${SITE_MAP.SOCIAL_NETWORK.REAL_ESTATE_POST.INDEX}`}
  >
    <img
      src='/logos/atm-nha-colored.svg'
      alt='ATM Nhà'
      loading='lazy'
      className='h-[40px] min-w-[132px]'
    />
  </Link>
);

export default HomeLink;
